import React, { useEffect, useRef } from "react";
import {
  // Avatar,
  TableCell,
  TableRow,
  TableCellLayout,
  PopoverTrigger,
  Popover,
  PopoverSurface,
  makeStyles,
  Tooltip,
} from "@fluentui/react-components";
import { useHistory } from "react-router-dom";
import useNavigation from "../../../../../utils/useNavigation";
import {
  FlagIcon,
  MeatBallsMenuIcon,
  PlusIcon,
} from "../../../../../modules/default-svg";
import { useState } from "react";
import {
  getAccountCurrency,
  dateOnlyFormatted,
  displayDecimalFormatted,
} from "../../../../../utils/systemSettings";
import CustomInput from "../../../input/customInput/CustomInput";
import CustomSelect from "../../../select/CustomSelect";
import DropDown from "../../../dropdown/DropdownFluent";
import {
  changeRequestPriorities,
  getLabelByType,
  ScopeStatus,
} from "../../../../../helpers/utils";
import {
  createScopeRequest,
  updateScopeRequest,
} from "../../../../../store/actions/scope.actions";
import { useDispatch } from "react-redux";
import clientService from "../../../../../store/services/clients.service";
import { apiCall } from "../../../../../store/services/service";
import { BASE_URL } from "../../../../../store/services/URL";
import { generalActions } from "../../../../../store/actions";

const useStyles = makeStyles({
  tooltip: {
    backgroundColor: "#342c82",
    color: "#FFFFFF",
  },
});

const ScopeRow = (props) => {
  const {
    sortingCriteria,
    data,
    handleModal,
    menu,
    clientId,
    parentType,
    projectId,
    programId,
    sortScopeItemsRequest,
    portfolioId,
    updateFlag,
    isMilestone,
    columnConfig,
  } = props;
  const settings = JSON.parse(localStorage.getItem("settings"));
  const [clients, setClients] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [sortedData, setSortedData] = useState([]);
  const [flagged, setFlagged] = useState([]);
  const [popoverOpen, setPopoverOpen] = useState({});
  const [isEditRecord, setIsEditRecord] = useState(null);
  const history = useHistory();
  const { navigateTo } = useNavigation();
  const popoverRef = useRef(null);
  const scopeNameRef = useRef(null);
  const managerInputRef = useRef(null);
  const phaseInputRef = useRef(null);
  const projectInputRef = useRef(null);
  const priorityInputRef = useRef(null);
  const budgetInputRef = useRef(null);
  const clientInputRef = useRef(null);
  const programInputRef = useRef(null);
  const portfolioInputRef = useRef(null);
  const startDateInputRef = useRef(null);
  const endDateInputRef = useRef(null);
  const progressInputRef = useRef(null);
  const dispatch = useDispatch();
  const [formErrors, setFormErrors] = useState({
    scopeName: "",
    startDate: "",
    endDate: "",
    revisedEndDate: "",
    progress: "",
    projectId: "",
  });

  const setRequestPriority = (type) => {
    switch (type) {
      case "Low":
        return 0;
      case "Moderate":
        return 1;
      case "High":
        return 2;
      default:
        return 0;
    }
  };

  const handleBlur = () => {
    let data = { ...isEditRecord.name };
    if (data.client) {
      data.clientId = data.client.id;
    } else {
      data.clientId = null;
    }
    if (data.portfolio) {
      data.portfolioId = data.portfolio.id;
    } else {
      data.portfolioId = null;
    }
    if (data.program) {
      data.programId = data.program.id;
    } else {
      data.programId = null;
    }
    if (data.project) {
      data.projectId = data.project.id;
    } else {
      data.projectId = null;
    }
    if (data.owner) {
      data.ownerId = data.owner.id;
    } else {
      data.ownerId = null;
    }
    if (data.id) {
      delete data.actual;
      delete data.accural;
      delete data.bac;
      delete data.etc;
      delete data.isFlagged;
      delete data.dateCreated;
    }

    const payload = {};
    payload.parent = parentType;
    if (parentType === "Client") {
      payload.parentID = clientId;
      payload.parent = "Client";
      data.clientId = clientId;
    }
    if (parentType === "Program") {
      payload.parentID = programId;
      payload.parent = "Program";
      data.programId = programId;
    }
    if (parentType === "Portfolio") {
      payload.parentID = portfolioId;
      payload.parent = "Portfolio";
      data.portfolioId = portfolioId;
    }
    if (parentType === "Project") {
      payload.parentID = projectId;
      payload.parent = "Project";
      data.projectId = projectId;
    }

    if (data.name && data.projectId) {
      if (data.id) {
        dispatch(
          updateScopeRequest({
            sId: isEditRecord.name.id,
            payload: data,
            ...payload,
          })
        );
      } else {
        data.isMilestone = true;
        dispatch(createScopeRequest({ payload: data, ...payload }));
      }
      setIsEditRecord(null);
    } else {
      const errors = {};
      if (!data.name) errors["scopeName"] = `The Name field is required.`;
      if (!data.project) errors["projectId"] = `The Project field is required.`;
      if (!data.name) {
        setFormErrors(errors);
        return dispatch(
          generalActions.showToast({
            title: "name is a required field",
            type: "error",
          })
        );
      } else if (!data.project) {
        return dispatch(
          generalActions.showToast({
            title: "Project is a required field",
            type: "error",
          })
        );
      }
    }
  };

  const handleEditable = (event) => {
    if (event.key === "Escape") {
      setIsEditRecord(null);
    } else if (event.key === "Enter") {
      if (isEditRecord) {
        handleBlur();
      }
    }
  };

  useEffect(() => {
    if (sortingCriteria.column !== null) {
      const payload = {
        page: 1,
        size: 10,
        orderBy: `${sortingCriteria.column} ${sortingCriteria.order}`,
      };
      if (parentType === "Scope") payload.parent = "Scope";
      if (parentType === "Project") {
        payload.id = projectId;
        payload.parent = "Project";
      }
      if (parentType === "Program") {
        payload.id = programId;
        payload.parent = "Program";
      }

      if (parentType === "Portfolio") {
        payload.id = portfolioId;
        payload.parent = "Portfolio";
      }
      sortScopeItemsRequest(payload);
    }
  }, [sortingCriteria]);

  const getPriority = (priority) => {
    switch (priority) {
      case 0:
        return "Low";
      case 1:
        return "Moderate";
      case 2:
        return "High";
      default:
        return "";
    }
  };
  const getPriorityPill = (priority) => {
    switch (priority) {
      case 0:
        return "pill OnTrack";
      case 1:
        return "pill OffTrack";
      case 2:
        return "pill AtRisk";
      default:
        return "";
    }
  };

  useEffect(() => {
    if (typeof data != "string") {
      data
        .filter((d) => d.isFlagged)
        .map((f) => {
          if (!flagged.includes(f.id)) {
            setFlagged((prevItems) => [...prevItems, f.id]);
          }
        });
      const tempData = [...data];
      tempData.push({
        name: "",
        client: null,
        portfolio: null,
        program: null,
        project: null,
        owner: null,
        status: 0,
        phase: "",
        budget: 0,
        priority: "",
      });
      setSortedData(tempData);
    }
  }, [data]);

  const handleRedirect = (item) => {
    // Use navigation hook instead of localStorage
    navigateTo("Milestones", item.id, item.name);
  };

  const handleClientRedirect = (item) => {
    if (parentType !== "Client") {
      // Use navigation hook for direct navigation to client
      navigateTo("Clients", item.client.id, item.client.name);
    } else {
      // Already in client context, just navigate
      history.push(`/clients/${item.client.id}/overview`);
    }
  };

  const handleProjectRedirect = (item) => {
    if (item.project) {
      // Use navigation hook for direct navigation to project
      navigateTo("Projects", item.project.id, item.project.name);
    }
  };

  useEffect(() => {
    if (menu.props.closePopover) {
      setPopoverOpen(null);
    }
  }, [menu.props.closePopover]);

  const handlePopoverOpen = (rowId) => {
    setPopoverOpen(rowId);
  };

  const handleClickOutside = (event) => {
    if (
      popoverRef.current &&
      !popoverRef.current.contains(event.target) &&
      event.target?.innerText !== "Edit" &&
      event.target?.innerText !== "Delete" &&
      event.target?.innerText !== "Remind me" &&
      event?.target?.tagName !== "svg"
    ) {
      if (popoverOpen) {
        handlePopoverOpen(null);
      }
    }
    if (
      isEditRecord &&
      event.target.localName !== "input" &&
      event.target.localName !== "div" &&
      event.target.className && // Ensure className exists
      typeof event.target.className === "string" && // Ensure className is a string
      !event.target.className.includes("fui-Dropdown__button")
    ) {
      handleBlur();
    } else if (isEditRecord && event.target.placeholder === "Search") {
      handleBlur();
    }
  };

  const handleScroll = (e) => {
    handlePopoverOpen(null);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("wheel", handleScroll);
    document.addEventListener("keydown", handleEditable);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("wheel", handleScroll);
      document.removeEventListener("keydown", handleEditable);
    };
  }, [isEditRecord, popoverOpen]);

  const handleInputChange = (value, type) => {
    let error = { ...formErrors };
    const data = JSON.parse(JSON.stringify(isEditRecord));
    if (type === "name") {
      error["scopeName"] = ``;
      setFormErrors(error);
      data.name.name = value;
      setIsEditRecord(data);
    } else if (type === "manager") {
      if (value) {
        if (!data?.name?.owner) {
          data.name.owner = {};
        }
        data.name.owner.name = value.label;
        data.name.owner.id = value.value;
      } else {
        data.name.owner = null;
      }

      setIsEditRecord(data);
    } else if (type === "status") {
      data.name.status = value;
      setIsEditRecord(data);
    } else if (type === "phase") {
      data.name.phase = value;
      setIsEditRecord(data);
    } else if (type === "project") {
      error["projectId"] = ``;
      setFormErrors(error);
      if (!value) {
        data.name.project = null;
      } else {
        if (!data.name?.project) {
          data.name.project = {};
        }
        data.name.project.name = value.label;
        data.name.project.id = value.value;
      }
      setIsEditRecord(data);
    } else if (type === "client") {
      if (!value) {
        data.name.client = null;
      } else {
        if (!data.name?.client) {
          data.name.client = {};
        }
        data.name.client.name = value.label;
        data.name.client.id = value.value;
      }
      data.name.project = null;
      data.name.portfolio = null;
      data.name.program = null;
      setIsEditRecord(data);
    } else if (type === "portfolio") {
      if (!value) {
        data.name.portfolio = null;
      } else {
        if (!data.name?.portfolio) {
          data.name.portfolio = {};
        }
        data.name.portfolio.name = value.label;
        data.name.portfolio.id = value.value;
      }
      data.name.program = null;
      data.name.project = null;
      setIsEditRecord(data);
    } else if (type === "program") {
      if (!value) {
        data.name.program = null;
      } else {
        if (!data.name?.program) {
          data.name.program = {};
        }
        data.name.program.name = value.label;
        data.name.program.id = value.value;
      }
      data.name.project = null;
      setIsEditRecord(data);
    } else if (type === "priority") {
      data.name.priority = setRequestPriority(value);
      setIsEditRecord(data);
    } else if (type === "budget") {
      data.name.budget = value;
      setIsEditRecord(data);
    } else if (type === "startDate") {
      data.name.startDate = value;
      setIsEditRecord(data);
    } else if (type === "endDate") {
      data.name.endDate = value;
      setIsEditRecord(data);
    }
  };

  const handleIsEdiRecord = (index, type) => {
    if (index === data.length) {
      sortedData[index] = {
        ...isEditRecord?.name,
      };
    }
    if (isEditRecord && isEditRecord.index === index) {
      focusField(type);
      return;
    }
    setIsEditRecord({ index: index, name: sortedData[index] });
    setTimeout(() => {
      focusField(type);
    }, 0);
  };

  const focusField = (type) => {
    switch (type) {
      case "scope":
        scopeNameRef.current?.focus();
        break;
      case "client":
        clientInputRef.current?.focus();
        break;
      case "program":
        programInputRef.current?.focus();
        break;
      case "portfolio":
        portfolioInputRef.current?.focus();
        break;
      case "budget":
        budgetInputRef.current?.focus();
        break;
      case "phase":
        phaseInputRef.current?.focus();
        break;
      case "project":
        projectInputRef.current?.focus();
        break;
      case "manager":
        managerInputRef.current?.focus();
        break;
      case "priority":
        priorityInputRef.current?.focus();
        break;
      case "startDate":
        startDateInputRef.current?.focus();
        break;
      case "endDate":
        endDateInputRef.current?.focus();
        break;
      case "progress":
        progressInputRef.current?.focus();
        break;
      default:
        break;
    }
  };

  ///////////////////////// FLAGGED fUNCTIONALITY /////////////////////////

  const addFlag = (id) => {
    setFlagged((prevItems) => [...prevItems, id]);
    updateFlag({
      id: id,
      payload: [
        {
          op: "replace",
          path: "/IsFlagged",
          value: true,
        },
      ],
    });
  };

  const removeFlag = (id) => {
    setFlagged((prevItems) => prevItems.filter((item) => item !== id));
    updateFlag({
      id: id,
      payload: [
        {
          op: "replace",
          path: "/IsFlagged",
          value: false,
        },
      ],
    });
  };

  useEffect(() => {
    const sortedArray = data;
    const tempData = [...sortedArray];
    tempData.push({
      name: "",
      client: null,
      portfolio: null,
      program: null,
      project: null,
      owner: null,
      status: 0,
      phase: "",
      budget: 0,
      priority: "",
    });
    setSortedData(tempData);
  }, [flagged]);

  const sortDataByFlagged = (dataArray, flaggedArray) => {
    const flaggedItems = [];
    const remainingItems = [];

    dataArray.forEach((item) => {
      if (flaggedArray.includes(item.id)) {
        flaggedItems.push(item);
      } else {
        remainingItems.push(item);
      }
    });

    flaggedItems.sort((a, b) => {
      return flaggedArray.indexOf(a.id) - flaggedArray.indexOf(b.id);
    });

    return [...flaggedItems, ...remainingItems];
  };

  const searchClientHandler = (value) => {
    if (value === "") {
      setClients([]);
      return;
    }
    clientService
      .searchClientsRequest(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setClients(transformedArray);
      })
      .catch(() => {
        setClients([]);
      });
  };

  const searchProjectHandler = (value) => {
    if (value === "") {
      setProjectOptions([]);
      return;
    }
    const payload = { searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;
    payload.parent = "Budget";

    if (isEditRecord?.name?.client) {
      queryParam = `?clientId=${isEditRecord?.name?.client?.id}&searchTerm=${payload.searchText}`;
    }

    if (isEditRecord?.name?.portfolio) {
      queryParam = `?portfolioId=${isEditRecord?.name?.portfolio?.id}&searchTerm=${payload.searchText}`;
    }

    if (isEditRecord?.name?.program) {
      queryParam = `?programId=${isEditRecord?.name?.program?.id}&searchTerm=${payload.searchText}`;
    }

    if (isEditRecord?.name?.client && isEditRecord?.name?.portfolio) {
      queryParam = `?clientId=${isEditRecord?.name?.client?.id}&portfolioId=${isEditRecord?.name?.portfolio?.id}&searchTerm=${payload.searchText}`;
    }

    if (isEditRecord?.name?.client && isEditRecord?.name?.program) {
      queryParam = `?clientId=${isEditRecord?.name?.client?.id}&programId=${isEditRecord?.name?.program?.id}&searchTerm=${payload.searchText}`;
    }

    if (isEditRecord?.name?.portfolio && isEditRecord?.name?.program) {
      queryParam = `?portfolioId=${isEditRecord?.name?.portfolio.id}&programId=${isEditRecord?.name?.program?.id}&searchTerm=${payload.searchText}`;
    }

    if (
      isEditRecord?.name?.client &&
      isEditRecord?.name?.portfolio &&
      isEditRecord?.name?.program
    ) {
      queryParam = `?clientId=${isEditRecord?.name?.client?.id}&portfolioId=${isEditRecord?.name?.portfolio?.id}&programId=${isEditRecord?.name?.program?.id}&searchTerm=${payload.searchText}`;
    }

    if (parentType === "Program") {
      queryParam = queryParam + `&programId=${programId}`;
    } else if (parentType === "Portfolio") {
      queryParam = queryParam + `&portfolioId=${portfolioId}`;
    }

    apiCall
      .get({ url: `${BASE_URL}search/Projects${queryParam}` })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          start: obj.startDate,
          end: obj.endDate,
          label: obj.name,
          value: obj.id,
        }));
        setProjectOptions(transformedArray);
      })
      .catch(() => {
        setProjectOptions([]);
      });
  };

  const styles = useStyles();

  // Sort columnConfig by order
  const sortedColumnConfig = [...columnConfig].sort(
    (a, b) => a.order - b.order
  );

  const renderTableCell = (item, index, column) => {
    const isEditing = isEditRecord && isEditRecord.index === index;

    switch (column.label) {
      case "Scope":
        return (
          <TableCell className={isEditing ? "" : "hoverCell"}>
            <div className="d-flex justify-content-between inputWidth">
              <div className="d-flex align-items-center inputWidth">
                {item?.id && (
                  <Tooltip
                    positioning="before"
                    content={{
                      children: flagged.includes(item.id) ? "Unflag" : "Flag",
                      className: styles.tooltip,
                    }}
                    relationship="label"
                    withArrow
                  >
                    <span
                      className={`flag ${
                        flagged.includes(item.id) ? "flagActive" : ""
                      }`}
                      onClick={() =>
                        flagged.includes(item.id)
                          ? removeFlag(item.id)
                          : addFlag(item.id)
                      }
                    >
                      <FlagIcon />
                    </span>
                  </Tooltip>
                )}
                {isEditing ? (
                  <CustomInput
                    inputwd="inputWidth me-3"
                    icon={false}
                    placeholder={
                      isMilestone ? "Add milestone name" : "Add scope name"
                    }
                    value={isEditRecord.name.name}
                    type="text"
                    handleChange={(value) => handleInputChange(value, "name")}
                    ref={scopeNameRef}
                    errorMessage={formErrors.scopeName}
                    displayErrorMessage={false}
                  />
                ) : (
                  <span
                    onClick={() => handleIsEdiRecord(index, "scope")}
                    className="text-truncate"
                  >
                    {item?.id ? (
                      <span
                        onClick={(e) => {
                          e.stopPropagation();
                          item?.id && handleRedirect(item);
                        }}
                      >
                        {item.name}
                      </span>
                    ) : (
                      <div
                        className="d-flex _add_btn"
                        onClick={() => handleIsEdiRecord(index, "scope")}
                      >
                        <PlusIcon />
                        Add
                      </div>
                    )}
                  </span>
                )}
              </div>
              {item?.id && (
                <div className="flag">
                  <Popover
                    {...props}
                    open={popoverOpen === item.id}
                    onOpenChange={(isOpen) =>
                      isOpen && handlePopoverOpen(item.id)
                    }
                    positioning="below-start"
                  >
                    <PopoverTrigger disableButtonEnhancement>
                      <TableCellLayout
                        media={<MeatBallsMenuIcon />}
                        onClick={() => handleModal(item)}
                      />
                    </PopoverTrigger>
                    <PopoverSurface
                      tabIndex={-1}
                      className="listingPopoverWrapper"
                    >
                      {menu}
                    </PopoverSurface>
                  </Popover>
                </div>
              )}
            </div>
          </TableCell>
        );
      case "Milestone":
        return (
          <TableCell className={isEditing ? "" : "hoverCell"}>
            <div className="d-flex justify-content-between inputWidth">
              <div className="d-flex align-items-center inputWidth">
                {item?.id && (
                  <Tooltip
                    positioning="before"
                    content={{
                      children: flagged.includes(item.id) ? "Unflag" : "Flag",
                      className: styles.tooltip,
                    }}
                    relationship="label"
                    withArrow
                  >
                    <span
                      className={`flag ${
                        flagged.includes(item.id) ? "flagActive" : ""
                      }`}
                      onClick={() =>
                        flagged.includes(item.id)
                          ? removeFlag(item.id)
                          : addFlag(item.id)
                      }
                    >
                      <FlagIcon />
                    </span>
                  </Tooltip>
                )}
                {isEditing ? (
                  <CustomInput
                    inputwd="inputWidth me-3"
                    icon={false}
                    placeholder={
                      isMilestone ? "Add milestone name" : "Add scope name"
                    }
                    value={isEditRecord.name.name}
                    type="text"
                    handleChange={(value) => handleInputChange(value, "name")}
                    ref={scopeNameRef}
                    errorMessage={formErrors.scopeName}
                    displayErrorMessage={false}
                  />
                ) : (
                  <span
                    onClick={() => handleIsEdiRecord(index, "scope")}
                    className="text-truncate"
                  >
                    {item?.id ? (
                      <span
                        onClick={(e) => {
                          e.stopPropagation();
                          item?.id && handleRedirect(item);
                        }}
                      >
                        {item.name}
                      </span>
                    ) : (
                      <div
                        className="d-flex _add_btn"
                        onClick={() => handleIsEdiRecord(index, "scope")}
                      >
                        <PlusIcon />
                        Add
                      </div>
                    )}
                  </span>
                )}
              </div>
              {item?.id && (
                <div className="flag">
                  <Popover
                    {...props}
                    open={popoverOpen === item.id}
                    onOpenChange={(isOpen) =>
                      isOpen && handlePopoverOpen(item.id)
                    }
                    positioning="below-start"
                  >
                    <PopoverTrigger disableButtonEnhancement>
                      <TableCellLayout
                        media={<MeatBallsMenuIcon />}
                        onClick={() => handleModal(item)}
                      />
                    </PopoverTrigger>
                    <PopoverSurface
                      tabIndex={-1}
                      className="listingPopoverWrapper"
                    >
                      {menu}
                    </PopoverSurface>
                  </Popover>
                </div>
              )}
            </div>
          </TableCell>
        );
      case "Client":
        return isEditing ? (
          <TableCell className="hoverCell">
            <CustomSelect
              SelectText="client"
              searchText={searchClientHandler}
              options={clients}
              defaultVal={
                isEditRecord.name.client
                  ? {
                      label: isEditRecord.name.client.name,
                      value: isEditRecord.name.client.id,
                    }
                  : null
              }
              onChange={(e) => handleInputChange(e, "client")}
              CustomClass="ModalAvatarSearch"
            />
          </TableCell>
        ) : item.client ? (
          <TableCell
            className="hoverCell"
            onClick={() => handleIsEdiRecord(index, "client")}
          >
            <span onClick={() => handleClientRedirect(item)}>
              {item.client?.name}
            </span>
          </TableCell>
        ) : (
          <TableCell
            onClick={() => handleIsEdiRecord(index, "client")}
          ></TableCell>
        );
      case "Project":
        return isEditing ? (
          <TableCell className="hoverCell">
            <CustomSelect
              SelectText="project"
              searchText={searchProjectHandler}
              options={projectOptions}
              defaultVal={
                isEditRecord.name.project?.name
                  ? {
                      label: isEditRecord.name.project.name,
                      value: isEditRecord.name.project.id,
                    }
                  : null
              }
              onChange={(e) => handleInputChange(e, "project")}
              CustomClass="ModalAvatarSearch"
              errorMessage={formErrors.projectId}
              displayErrorMessage={false}
            />
          </TableCell>
        ) : item.project && parentType !== "Project" ? (
          <TableCell
            className="hoverCell"
            onClick={() => handleIsEdiRecord(index, "project")}
          >
            <span onClick={() => handleProjectRedirect(item)}>
              {item.project.name}
            </span>
          </TableCell>
        ) : (
          <TableCell></TableCell>
        );
      // case "Scope Manager":
      //   return (
      //     <TableCell
      //       role="gridcell"
      //       onClick={() => handleIsEdiRecord(index, "manager")}
      //     >
      //       {isEditing ? (
      //         <CustomSelect
      //           SelectText="manager"
      //           searchText={searchHandler}
      //           options={resources}
      //           defaultVal={
      //             isEditRecord.name.owner?.name
      //               ? {
      //                   label: isEditRecord.name.owner.name,
      //                   value: isEditRecord.name.owner.id,
      //                 }
      //               : null
      //           }
      //           onChange={(e) => handleInputChange(e, "manager")}
      //           creatable={true}
      //           setCreated={setOwnerId}
      //           CustomClass="ModalAvatarSearch"
      //           handleInputChange={handleInputChange}
      //         />
      //       ) : item.owner ? (
      //         <TableCellLayout
      //           media={
      //             <HoverCard
      //               HoverCardTrigger={
      //                 <Avatar
      //                   color="colorful"
      //                   name={item.owner ? item.owner.name : ""}
      //                   image={{
      //                     src: item.owner.image ? item.owner.image : "",
      //                   }}
      //                 />
      //               }
      //               AvatarId={item.owner?.id}
                    // AvatarName={item.owner?.name}
                    // AvatarImage={item.owner?.image}
                    // AvatarDesignation={item.owner?.title}
                    // AvatarEmail={item.owner?.email}
                    // AvatarPhone={item.owner?.phoneNumber}
                    // AvatarIsExternal={item.owner?.isExternal}
      //             />
      //           }
      //         >
      //           {item.owner ? item.owner.name : ""}
      //         </TableCellLayout>
      //       ) : (
      //         ""
      //       )}
      //     </TableCell>
      //   );
      case "Phase":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "phase")}>
            {isEditing ? (
              <CustomInput
                inputwd="inputWidth me-3"
                icon={false}
                placeholder="Enter phase"
                value={isEditRecord.name.phase}
                type="text"
                handleChange={(value) => handleInputChange(value, "phase")}
                ref={phaseInputRef}
              />
            ) : (
              item.phase
            )}
          </TableCell>
        );
      case "Status":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "status")}>
            <p
              className={
                isEditing
                  ? ""
                  : !item?.id
                  ? ""
                  : `pill ${
                      item.status === 0
                        ? "OnTrack"
                        : item.status === 1
                        ? "OffTrack"
                        : item.status === 2
                        ? "AtRisk"
                        : "Completed"
                    }`
              }
            >
              {isEditing ? (
                <DropDown
                  label="Status"
                  showLabel={false}
                  options={ScopeStatus}
                  defaultVal={isEditRecord.name.status}
                  onChange={(e) => handleInputChange(e, "status")}
                  isInlineFocus={true}
                />
              ) : (
                item?.id && getLabelByType("scope", item.status)
              )}
            </p>
          </TableCell>
        );
      case "Priority":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "priority")}>
            {isEditing ? (
              <DropDown
                label="Priority"
                showLabel={false}
                options={changeRequestPriorities}
                defaultVal={getPriority(isEditRecord.name.priority)}
                onChange={(e) => handleInputChange(e, "priority")}
                ref={priorityInputRef}
                isInlineFocus={true}
              />
            ) : (
              <p className={getPriorityPill(item.priority)}>
                {getPriority(item.priority)}
              </p>
            )}
          </TableCell>
        );
      case "Budget":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "budget")}>
            {isEditing ? (
              <CustomInput
                inputwd="inputWidth me-3"
                icon={false}
                placeholder="0"
                value={isEditRecord.name.budget}
                type="number"
                currency={true}
                inline={true}
                handleChange={(value) => handleInputChange(value, "budget")}
                ref={budgetInputRef}
              />
            ) : (
              item?.id &&
              `${getAccountCurrency(settings)} ${displayDecimalFormatted(
                settings,
                item.budget
              )}`
            )}
          </TableCell>
        );
      case "Actual":
        return (
          <TableCell>
            {item?.id
              ? `${getAccountCurrency(settings)} ${displayDecimalFormatted(
                  settings,
                  item.actual
                )}`
              : ""}
          </TableCell>
        );
      case "Accural":
        return (
          <TableCell>
            {item?.id
              ? `${getAccountCurrency(settings)} ${displayDecimalFormatted(
                  settings,
                  item.accural
                )}`
              : ""}
          </TableCell>
        );
      case "ETC":
        return (
          <TableCell>
            {item?.id
              ? `${getAccountCurrency(settings)} ${displayDecimalFormatted(
                  settings,
                  item.etc
                )}`
              : ""}
          </TableCell>
        );
      case "BAC":
        return (
          <TableCell>
            {item?.id
              ? `${getAccountCurrency(settings)} ${displayDecimalFormatted(
                  settings,
                  item.bac
                )}`
              : ""}
          </TableCell>
        );
      case "Tasks":
        return (
          <TableCell>
            {item?.id
              ? `${displayDecimalFormatted(settings, item.tasksCount)}`
              : ""}
          </TableCell>
        );
      case "Start Date":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "startDate")}>
            {isEditing ? (
              <CustomInput
                value={isEditRecord.name.startDate}
                type="date"
                handleChange={(value) => handleInputChange(value, "startDate")}
                ref={startDateInputRef}
              />
            ) : item.startDate ? (
              dateOnlyFormatted(settings, item.startDate)
            ) : (
              ""
            )}
          </TableCell>
        );
      case "End Date":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "endDate")}>
            {isEditing ? (
              <CustomInput
                value={isEditRecord.name.endDate}
                type="date"
                handleChange={(value) => handleInputChange(value, "endDate")}
                ref={endDateInputRef}
              />
            ) : item.endDate ? (
              dateOnlyFormatted(settings, item.endDate)
            ) : (
              ""
            )}
          </TableCell>
        );
      case "%":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "progress")}>
            {isEditing ? (
              <CustomInput
                inputwd="inputWidth me-3"
                icon={false}
                placeholder="0"
                value={isEditRecord.name.progress}
                type="number"
                currency={true}
                inline={true}
                handleChange={(value) => handleInputChange(value, "progress")}
                ref={progressInputRef}
              />
            ) : (
              item?.id && `${item.progress}%`
            )}
          </TableCell>
        );
      default:
        return <TableCell></TableCell>;
    }
  };

  return sortedData.map((item, index) => (
    <TableRow
      key={item.id || `new-${index}`}
      className="ScopeHover"
      ref={popoverRef}
    >
      {sortedColumnConfig
        .filter((col) => col.isVisible)
        .map((col) => renderTableCell(item, index, col))}
    </TableRow>
  ));
};

export default ScopeRow;
